import { render, staticRenderFns } from "./PaxInfoForm.vue?vue&type=template&id=802f37a8&"
import script from "./PaxInfoForm.vue?vue&type=script&lang=js&"
export * from "./PaxInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./PaxInfoForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports